// extracted by mini-css-extract-plugin
export default {"successMsg":"SuccessMessage__successMsg___VtiJT","successMsgText":"SuccessMessage__successMsgText___DYG8D"};